



























































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { integrationWebservice } from '@/webservices/integration';
import type { Integration } from '@/models/integration';
import type { CompanySetting } from '@/models/companySetting';
import ConfirmModal from '@/components/prine/ConfirmModal.vue';
import type { MicrosoftUser } from '@/models/microsoftUser';
import IntegrationMoreInfoModal from '@/components/IntegrationMoreInfoModal.vue';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

interface IMicrosoftIntegration extends Integration {
    admin: MicrosoftUser;
}

@Component({
    name: 'MicrosoftIntegration',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        ConfirmModal,
        IntegrationMoreInfoModal,
    },
})
export default class MicrosoftIntegration extends Vue {
    // Data
    public isConfirmModalActive: boolean = false;
    public integration: IMicrosoftIntegration | null = null;
    public moreInfoShowModalActive: boolean = false;

    @Getter('account/companySetting') public companySetting: CompanySetting;

    public async initConnect(integration: Integration) {
        if (!this.companySetting.feature_integrations) {
            return false;
        }

        window.location.href = await integrationWebservice.authorizeLink(integration);
    }

    public toggleConfirmModal(answer = false, integration: IMicrosoftIntegration | null = null) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (integration) {
            this.integration = integration;
        }
        if (answer && this.integration) {
            this.revoke(this.integration);
        }
    }

    private async revoke(integration: Integration) {
        await integrationWebservice.revoke(integration);
        this.load();
    }

    private mounted() {
        this.load();
    }

    private load() {
        this.loadMicrosoftIntegration();
    }

    private async loadMicrosoftIntegration() {
        try {
            this.integration = (await integrationWebservice.getMicrosoft()) as IMicrosoftIntegration;
        } catch (error) {
            console.error(error);
        }
    }
}
